import { useForm } from "react-hook-form";
import { Textarea, TextInput } from "react-hook-form-mantine";
import resolver from "@congrs/resolver";
import LocalizedInput from "../../common/LocalizedInput";
import { web_locationFormSchema } from "@congrs/schemas";
import {
  makeI18nDefaultValue,
  mergeI18nWithDefaults,
} from "../../../utils/i18nUtils";

function LocationForm({ location, onSubmit, event, formId }) {
  const mainLanguage = event?.language || "en";
  const otherLanguages = event?.secondaryLanguages || [];

  const defaultValues = {
    eventId: event.id,
    nameI18n: location?.nameI18n
      ? mergeI18nWithDefaults(location.nameI18n, mainLanguage, otherLanguages)
      : makeI18nDefaultValue(mainLanguage, otherLanguages),
    descriptionI18n: location?.descriptionI18n
      ? mergeI18nWithDefaults(
          location.descriptionI18n,
          mainLanguage,
          otherLanguages
        )
      : makeI18nDefaultValue(mainLanguage, otherLanguages),
    picture: location?.picture || "",
  };

  const { control, handleSubmit: formSubmit } = useForm({
    defaultValues,
    resolver: resolver(web_locationFormSchema),
  });

  const localizedInput = [
    {
      nameBase: "nameI18n",
      label: "Location name",
      component: TextInput,
      props: {
        withAsterisk: true,
        placeholder: "Name",
        mt: "sm",
      },
    },
    {
      nameBase: "descriptionI18n",
      label: "Description",
      component: Textarea,
      props: {
        rows: 2,
        placeholder:
          "Description (e.g. the location is on the 3rd floor of the building, room 301)",
        autosize: true,
        mt: "sm",
      },
    },
  ];

  return (
    <form id={formId} onSubmit={formSubmit(onSubmit)}>
      <LocalizedInput
        control={control}
        fields={localizedInput}
        mainLanguage={mainLanguage}
        otherLanguages={otherLanguages}
      />
    </form>
  );
}

export default LocationForm;
